import insightsMobile from '../images/screenshots/destinationcore-insights/mobile.webp';
import { resolveVideoUrl } from '../utils/video';

export const services = [
    {
        title: 'Web Design & Build',
        category: 'web-design-and-build',
        src: resolveVideoUrl('videos/southend-care/scroll.mp4')!,
        video: true,
        description: 'Content-managed websites and online stores built on Craft CMS and Shopify — editor-friendly, fast, and built to last. Your team stays in control, no developers required for day-to-day updates.'
    },
    {
        title: 'Web Applications',
        category: 'applications',
        src: resolveVideoUrl('videos/licklibrary/scroll.mp4')!,
        video: true,
        description: 'Custom web applications that replace the manual processes slowing your organisation down — automating process steps, surfacing insights from your data, and integrating with your existing tools.'
    },
    {
        title: 'AI Implementation',
        category: 'ai-implementation',
        src: insightsMobile.src,
        video: false,
        description: 'Practical AI that saves your team hours every week — integrated with the systems your team already use. Liberate your team from the busywork and let them focus on the work that really matters.'
    },
    {
        title: 'Data Visualisation',
        category: 'data-visualisation',
        src: resolveVideoUrl('videos/pandemic-pact/scroll.mp4')!,
        video: true,
        description: 'Clear, interactive dashboards that turn your data into decisions — pipelines that refine and cleanse your data, and visualisations that allow users to explore and draw insights on their own.'
    }
];